export const images = {
  addCustomerThumbnail: require('./AddCustomerThumbnail.png'),
  backgroundPersons: require('./backgroundPersons.webp'),
  play: require('./play.png'),
  zetIcon: require('./zetIcon.png'),
  accountCreated: require('./accountCreated.webp'),
  sbmLogo: require('./sbmLogo.png'),
  zet_splash1x: require('./zet_splash1x.webp'),
}
